import { Component, HostListener, ViewEncapsulation, inject } from '@angular/core';
import { ExpansionPanelComponent } from './expansion-panel.component';

@Component({
  selector: 'app-expansion-panel-header',
  templateUrl: './expansion-panel-header.component.html',
  styleUrls: ['./expansion.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-expansion-panel-header',
    role: 'button',
    tabindex: '0',
    '[attr.id]': 'panel.headerId',
    '[attr.aria-controls]': 'panel.contentId',
    '[attr.aria-expanded]': 'panel.expanded',
  },
})
export class ExpansionPanelHeaderComponent {
  protected readonly panel = inject(ExpansionPanelComponent);

  @HostListener('click')
  onClick(): void {
    this.panel.toggle();
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.panel.toggle();
    }
  }
}
